const filterNodes = {
  parent: document.getElementById('main-collection-filters'),
  gridsContainer: document.getElementById('product-grids'),
  activeFilters: document.querySelector('[data-active-filters]'),
  drawerFooter: document.querySelector('[data-filterFooter]'),
  openDrawerBtns: document.querySelectorAll('[data-openFilterDrawer]'),
  closeDrawer: document.querySelector('[data-closeFilter]')
}
const Filter_utility = {
  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @return {String} value - formatted value
   */
	formatMoney(cents, format) {
    if (format == null || format == undefined){
      format = window.globalVariables.money_format || "${{ amount }}";
    }
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);
    function defaultOption(opt, def) {
      
      return (typeof opt == 'undefined' ? def : opt);
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) { return 0; }
      number = (number/100.0).toFixed(precision);
      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cents;
    }
    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
    return formatString.replace(placeholderRegex, value);
  },
   debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  },
}
if(filterNodes.parent){
  class CollectionFilters {
    constructor() {
      this.filterForm = filterNodes.parent.querySelector('form');
  
      filterNodes.parent.addEventListener('keyup', (event) => {
        if(event.code && event.code.toUpperCase() === 'ESCAPE') filterNodes.closeDrawer.dispatchEvent(new Event('click'));
      });
  
      this.debouncedOnSubmit = Filter_utility.debounce((event) => {
        this.onSubmitHandler(event);
      }, 500);
  
      if(this.filterForm){
        this.filterForm.addEventListener('input', (evt)=>{
          if((evt && evt.target.type == 'range') || window.innerWidth < 992) return false;
          this.debouncedOnSubmit(evt);
        });
        this.filterForm.addEventListener('submit', this.debouncedOnSubmit.bind(this));
       
        // window.addEventListener('popstate', this.onHistoryChange.bind(this));
      }
      
      this.bindEvents();
      this.dynamicEleEvents();
    }
  
    /**
     * bind dclick and keyup event to Cart Icons
     * bind keyUp event to Cart drawer component
     * bind Other inside element events
     *
    */
    bindEvents() {
      /** There are two open drawer buttons, one for Open filter drawer other for open sortby drawer **/
      if(filterNodes.openDrawerBtns.length > 0){
      
        filterNodes.openDrawerBtns.forEach(button => button.addEventListener('click', this.toggleFilterDrawer.bind(this)));
      }
      if (filterNodes.closeDrawer) {
        filterNodes.closeDrawer.addEventListener('click', this.toggleFilterDrawer.bind(this));
      }
      if (document.querySelectorAll("#CollectionFiltersForm .panel_toggle")) {
        document.querySelectorAll("#CollectionFiltersForm .panel_toggle").forEach(button => button.addEventListener('click', this.toggleFilter.bind(this)));
      }    
      let sortby_desktop = document.querySelectorAll('.sortby-dropdown');
      sortby_desktop.forEach(input => input.addEventListener('change', this.updateSortBy.bind(this)));

    }
    
    dynamicEleEvents() {
  
      const applyBtn = filterNodes.parent.querySelector('[data-applyFilters]');
      if(applyBtn){
        applyBtn.addEventListener('click', () => {
          const searchParams = this._createQueryString(this.filterForm)
          this.renderPage(searchParams);
        });
      }
  
  
      this.bindActiveFilterButtonEvents();
    }
  
    /**
     * Collection filter form Input event
     * @param {event} event Event Instance
     */
    onSubmitHandler(event) {
      event.preventDefault();
      const searchParams = this._createQueryString(this.filterForm)
      this.renderPage(searchParams);
    }
  
    /**
     * click event To Remove current selections
     * @param {element} form Collection page filter form
     */
    _createQueryString(form){
      const formData = new FormData(form);
      if(form.querySelector('[name="filter.v.price.gte"]')){
        const priceGTE = form.querySelector('[name="filter.v.price.gte"]').min;
        const priceLTE = form.querySelector('[name="filter.v.price.lte"]').max;
  
        if(parseInt(formData.get('filter.v.price.gte')) == parseInt(priceGTE)){
          formData.delete('filter.v.price.gte');
        }
        if(parseInt(formData.get('filter.v.price.lte')) == parseInt(priceLTE)){
          formData.delete('filter.v.price.lte');
        }
      }
      return new URLSearchParams(Array.from(formData)).toString();
    }
  
    /**
     * 
     * @param {String} searchParams Query Parameters
     * @param {String} updateURLHash true/false
    */
    renderPage(searchParams, updateURLHash = true) {
  
      const url = `${window.location.pathname}?${searchParams}`;
      this.renderGridFromFetch(url, 'filter');
  
      if (updateURLHash) this.updateURLHash(searchParams);
    }

  
    /**
     * click event To Remove current selections
     * @param {event} event Event Instance
     */
     onActiveFilterClick(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
  
      let URLString = new URL(event.currentTarget.href).searchParams.toString();
      if(URLString != null) this.renderPage(URLString);
    }
  
     /**
     * Update Window URL as per active filters
     * @param {event} event Event Instance
     */
    onHistoryChange(event) {
      const searchParams = event.state?.searchParams || '';
      this.renderPage(searchParams, false);
    }
  
    /**
     * 
     * @param {String} url URL for fetching results
     * @param {String} type filter / pagination / sub_collection
     */
    renderGridFromFetch(url, type) {
      if(!url) return;
  
      let sectionID = document.getElementById('product-grids').dataset.id;
      url += `&sections=${sectionID}`;
     
      fetch(url)
        .then(response => response.json())
        .then((response) => {
          let gridHTML = response[sectionID];
          this.renderProductGrid(type, gridHTML);
        });
    }
  
    /**
     * 
     * @param {HTMlResponse} html 
     * @param {String} type filter / pagination / sub_collection
     */
    renderProductGrid(type, grid, banner) {
      const collectionParent = new DOMParser().parseFromString(grid, 'text/html');
      const gridsHTML = collectionParent.getElementById('product-grids').innerHTML;
      filterNodes.gridsContainer.innerHTML = gridsHTML;
      
      
      const filterPanels = collectionParent.querySelectorAll('#CollectionFiltersForm .filter__container');
      document.querySelectorAll('#CollectionFiltersForm .filter__container').forEach(panel => panel.classList.add('d-none'));
      filterPanels.forEach((panel)=> {
        let filterBlock = document.querySelector('.filter__container[data-index="'+panel.dataset.index+'"]');
        if(filterBlock){
          filterBlock.querySelector('.filter__block').innerHTML = panel.querySelector('.filter__block').innerHTML;
          filterBlock.classList.remove('d-none');
        }
      });
  
      filterNodes.drawerFooter.innerHTML = collectionParent.querySelector('[data-filterFooter]').innerHTML;
  
      const activeFilters = collectionParent.querySelector('[data-activeFilters]');
      if(activeFilters) filterNodes.activeFilters.innerHTML = activeFilters.innerHTML;
      this.dynamicEleEvents();
  
  
      let drawerOpen = filterNodes.parent.classList.contains('filter-active');
      if(drawerOpen) filterNodes.closeDrawer.dispatchEvent(new Event('click'));
    }
  
    /**
     * Re-Binding events on active filters after ajax request
     */
    bindActiveFilterButtonEvents() {
      let removeActiveFilters = Array.from(document.getElementsByClassName('filter-option-clear'));
      removeActiveFilters.forEach((element) => {
        element.addEventListener('click', this.onActiveFilterClick.bind(this), { once: true });
      });
    }
  
    /**
     * Update the url
     * @param {String} searchParams 
     */
    updateURLHash(searchParams) {
      history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    }
  
    /**
     * 
     * @param {event} event 
     */
    updateSortBy(event){
      let currentEle = event.currentTarget;
      let targetOpt = this.filterForm.querySelector(`input[name="sort_by"][value="${currentEle.value}"]`);
      if(targetOpt){
        targetOpt.checked = true;
        this.filterForm.dispatchEvent(new Event('input', {
          once: true,
        }));
      }
    }
  
    /**
     * Toggle Filter drawer
     * @param {event} event 
     */
    toggleFilterDrawer(event){
      event.preventDefault();
      let button = event.currentTarget;
      if(button.id == 'filter-drawer'){
        filterNodes.parent.classList.add('filter-active');
      }else{
        filterNodes.parent.classList.remove('filter-active');
      }
    }
    /**
     * Toggle Filter drawer
     * @param {event} event 
     */
    toggleFilter(event){
      event.preventDefault();
      let button = event.currentTarget;
      let container = button.closest('.filter__container');     
      if (container.classList.contains("is_open")) {
          container.classList.remove("is_open");
      } else {
          container.classList.add("is_open");
      }

    }
  }
  typeof CollectionFilters !== 'undefined' && new CollectionFilters();

}


class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  /**
   * 
   * @param {event} event 
   */
  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}
customElements.define('price-range', PriceRange);

class PriceRangeSlider extends HTMLElement {
  constructor() {
    super();

    let _this = this;
    let form = this.closest('form');
    let sliderSections = this.getElementsByClassName("range-slider");

    for(const element of sliderSections){
      let sliders = element.getElementsByTagName("input");
      for(const element of sliders){
        if(element.type === "range" ){
          element.oninput = _this.getVals;
          element.oninput();

          if(form && form.id == 'CollectionFiltersForm'){
            element.onchange = (_evt)=>{
              if(window.innerWidth >= 992) form.dispatchEvent(new CustomEvent('submit'));
            } 
          }
        }
      }
    }
  }
  
  // Get Price value from both range slider
  getVals(){
    let parent = this.parentNode;
    let slides = parent.getElementsByTagName("input");
    let slide1 = parseFloat(slides[0].value);
    let slide2 = parseFloat(slides[1].value);
      
    // Neither slider will clip the other, so make sure we determine which is larger
    if( slide1 > slide2 ){ let tmp = slide2; slide2 = slide1; slide1 = tmp; }
    
    let displayElement = parent.getElementsByClassName("rangeValues")[0];
    displayElement.innerHTML = Filter_utility.formatMoney((slide1*100), `${window.globalVariables.money_format} - ${Filter_utility.formatMoney((slide2*100), window.globalVariables.money_format)}`);
  }
}
customElements.define('range-slider', PriceRangeSlider);